import React, { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { ErrorMessage } from 'components/atoms'
import { ContentPresenter } from 'components/molecules'
import useGetContentByIdFiltered from 'hooks/useGetContentByIdFiltered'

import { S169Container } from './styled'

const Preview = () => {
  const [searchParams] = useSearchParams()
  const contentType = searchParams.get('type')
  const contentId = searchParams.get('documentId')
  const status = searchParams.get('status')
  const locale = searchParams.get('locale')

  const NotFound = useCallback(() => <ErrorMessage title='404' subtitle='Content Not Found' />)

  const params = useMemo(
    () => ({
      status,
      locale,
      populate: '*',
    }),
    [status, locale]
  )

  const content = useGetContentByIdFiltered(contentType, contentId, params)

  return (
    <S169Container>
      {content.data === null && <NotFound />}
      {content.data && <ContentPresenter content={content.data} contentType={contentType} />}
    </S169Container>
  )
}

export default Preview
